import React from 'react'
import Navbar from '../inc/Navbar'

import { Link } from "react-router-dom";

import ScrollToTop from "react-scroll-to-top";



function Welcome() {
  return (
    <div>
        <Navbar/>
        <br/>
        <br/>
           <div className="album py-1">
                <div className="container">
                    <h1> KRISHNAGAR PUBLIC SCHOOL </h1>
                </div>
            </div>
        <div className='cbscschoolnadia'>
        <div className='album py-1'>
          <div className='container mt-3'>
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li style={{ color: "white" }} className="breadcrumb-item"><Link to="/" style={{ color: "darkBLue" }} >Home</Link></li>
                <li className="breadcrumb-item active" style={{ color: "darkBLue" }} aria-current="page">Welcome Address <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-double-right" viewBox="0 0 16 16">
                  <path fill-rule="evenodd" d="M3.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L9.293 8 3.646 2.354a.5.5 0 0 1 0-.708" />
                  <path fill-rule="evenodd" d="M7.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L13.293 8 7.646 2.354a.5.5 0 0 1 0-.708" />
                </svg></li>
              </ol>
            </nav>
          </div>
        </div>
        </div>
        <ScrollToTop smooth top="100" color="darkgoldenrod"/>
        <br/>
        <div className="album py-0">
                    <div className="container">
                        
                            <div className="card-body">
                              <div className='welcometext'>
                                        <h1 className="card-title"><b>Welcome Address</b></h1>
                                        </div>
                                        <h6>Dear Parents</h6>
                                        <p className='mb-2'>A warm welcome to Krishnagar Public School!  </p>
                                        <p className='justify mb-2'>Established in 2016, as a result of the futuristic vision of Shri Naresh Chandra Das, Krishnagar Public School is a co-educational senior secondary school, affiliated to Central Board of Secondary Education, New Delhi with state-of-the-art infrastructure, a dedicated team of trained and experienced teachers and a futuristic pedagogical approach that is custom-made for hand-holding the students into the 21st century world.  </p>
                                        <p className='justify mb-2'>We believe that children should be at the centre of all activities in a school and that they should be taught the way they learn best and not made to learn the way they are taught. For us at KPS, students are not mere roll numbers, they are unique individuals with their unique personalities and potentials that should be nurtured with care, compassion and empathy to suit their needs and aspirations. </p>

                                        <p className='justify mb-2'>Our mission is to help each child identify their own unique potential and provide them with support, guidance and platform to achieve their true capabilities. We believe more in training our students how to learn than merely delivering content so that they turn out to be life-long learners, compassionate human beings, contented individuals and successful future leaders. We put values and attitudes at the centre of our curriculum and train our students to hold onto their local flavour while imbibing the true spirit of nationalism and emerging out to be global citizens. We are always on to our research of the latest pedagogical approaches to help students develop the flexibility, adaptability, entrepreneurship skills to ease into the world as they step out of the boundaries of the school as young adults. </p>

                                        <p className='justify mb-2'>As you flip through this prospectus, you will unwrap different ethos and aspects that will truly make your ward's experience with us unique and special. We look forward to having further association with you.  </p>
                                        <div className="d-flex justify-content-end align-items-end mb-0">
                                    <div className='teamkps'>
                                        <p className='mb-0'>Warm regards,</p>
                                        <h5>Team KPS</h5>
                                        </div>
                                    
                                </div>
</div>
</div>
</div>
      

      
    </div>
  )
}

export default Welcome